import { Injectable, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractFormControl } from './abstract-form-control';

@Injectable()
export abstract class AbstractFormControlComponent<
  T extends AbstractFormControl
> {
  @Input() parentForm: FormGroup;
  @Input() title: string;
  @Input() formControlName: string;

  get isRequired(): boolean {
    return this.control?.isRequired ?? false;
  }

  get isDisabled(): boolean {
    return this.control?.isDisabled ?? false;
  }

  get control(): T {
    return this.parentForm.get(this.formControlName) as T;
  }
}
